module.exports = __webpack_public_path__ + "img/灵感.f1a943e3.gif";